// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1qYP1","filesListContainer":"PosDisputesFiles_filesListContainer__3TQ_Z","filesButton":"PosDisputesFiles_filesButton__3_Ga1"};